<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>ACTUALIZAR ASESOR</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">

      <div class="p-6">

        <!-- DATOS SHOW -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <p><span class="font-semibold">Cliente: </span>{{names_client}} {{surnames_client}}</p>
            <p><span class="font-semibold">Email cliente: </span>{{email_client}}</p>
            <p><span class="font-semibold">Asesor asignado: </span>{{full_name_employee}}</p>
            <p><span class="font-semibold">Generador asignación: </span>{{full_name_generator_employee}}</p>
            <p><span class="font-semibold">Fecha actualización: </span>{{updated_at_assigned_advisor | formato_fecha2}}</p>
            <p class="hidden"><span class="font-semibold">ID assigned advisor: </span>{{id_assigned_advisor}}</p>
          </div>
        </div>

        <vs-divider/>

        <!-- SELECCIONAR ASESOR  -->
        <div class="vx-row">
          <div class="vx-col w-full mt-4">
            <label class="vs-input--label">Cambiar asesor:</label>
            <v-select :closeOnSelect="true" v-model="id_employee" label="name_employee" :options="employees" name="id_employee" :reduce="employees => employees.id_employee">
              <template #option="{ name_employee, surname_employee }">
                <span>{{ name_employee }} {{ surname_employee }}</span>
              </template>
              <template #selected-option="{ name_employee, surname_employee }">
                <span>{{ name_employee }} {{ surname_employee }}</span>
              </template>
            </v-select>
          </div>
        </div>

      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Ingresar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { email_client, full_name_employee, full_name_generator_employee, id_assigned_advisor, id_client, id_employee, id_generator_employee, name_employee, names_client, surname_employee, surnames_client, updated_at_assigned_advisor } = JSON.parse(JSON.stringify(this.data))
        this.email_client = email_client
        this.full_name_employee = full_name_employee
        this.full_name_generator_employee = full_name_generator_employee
        this.id_assigned_advisor = id_assigned_advisor
        this.id_client = id_client 
        this.id_employee = id_employee
        this.id_generator_employee = id_generator_employee
        this.name_employee = name_employee
        this.names_client = names_client
        this.surname_employee = surname_employee
        this.surnames_client = surnames_client
        this.updated_at_assigned_advisor = updated_at_assigned_advisor
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data () {
    return {
      names_client: '',
      surnames_client: '',
      email_client: '',
      full_name_employee: '', 
      full_name_generator_employee: '', 
      updated_at_assigned_advisor: '', 
      id_assigned_advisor: '',
      id_employee: '',

      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    employees () {
      return this.$store.state.employees
    },
    isFormValid () {
      return !this.errors.any() && this.id_employee
    }
  },
  methods: {
    initValues () {
      if (this.data.id_assigned_advisor) return
      this.id_assigned_advisor = null
      this.id_employee = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.id_assigned_advisor,
            employee_id: this.id_employee
          }
          this.$vs.loading()
          this.$store.dispatch('updateItemAssignedAdvisor', obj)
            .then(() => { this.$emit('closeSidebar') })
            .then(() => { this.$vs.loading.close() })
            .then(() => {
              this.$vs.notify({
                title: 'Asesor cambiado',
                text: 'Se ha cambiado el asesor correctamente',
                color: 'success',
                iconPack: 'feather',
                icon:'icon-check',
                time: 4000
              }) 
            })
            .then(() => { this.initValues() })
            .catch(err => { 
              this.$vs.loading.close()
              // console.log(Object.getOwnPropertyNames(err))
              console.error(err)
              // console.log(err.response.data.errors)
              const mensaje_error = err.response.data.errors
              const array_errors = Object.entries(mensaje_error)

              for (let i = 0; i < array_errors.length; i++) {
                this.$vs.notify({
                  title: 'Error',
                  text: `${array_errors[i][1][0]}`,
                  iconPack: 'feather',
                  icon: 'icon-x-circle',
                  color: 'warning',
                  time: 6000
                })
              }
            })
            // this.$emit('closeSidebar')
            // this.initValues()
        }
      })
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}

.demo-alignment {
  margin-top:-15px;
}
</style>
